var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWorkspaceinline = function SvgWorkspaceinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C72E7",
    d: "M6.107.2a.982.982 0 0 0-.982.981v6.876a.982.982 0 0 0 .982.982h4.91v1.964H9.054a.981.981 0 0 0-.995.982H1.196a.982.982 0 1 0 0 1.965v8.839a.982.982 0 1 0 1.964 0v-4.91h17.68v4.91a.982.982 0 1 0 1.964 0V13.95a.982.982 0 1 0 0-1.965h-6.862a.984.984 0 0 0-.995-.982h-1.965V9.04h4.911a.982.982 0 0 0 .982-.982V1.18a.982.982 0 0 0-.982-.98H6.107Zm.982 1.964h9.822v4.91h-4.76a.983.983 0 0 0-.308 0H7.089v-4.91ZM12 13.95a.982.982 0 1 1 0 1.965.982.982 0 0 1 0-1.965Z"
  })));
};

export default SvgWorkspaceinline;